import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
export interface Crumb {
  label: string;
  href?: string;
}
export function Breadcrumbs({
  items
}: {
  items: Crumb[];
}) {
  return <nav aria-label="Breadcrumb" data-id="element-183" data-mp="1jeoos6miofzr">
      <ol className="flex flex-wrap items-center gap-1.5 text-xs text-muted" data-id="element-184" data-mp="1jdnbdvi13hev">
        {items.map((c, i) => <li key={c.label} className="flex items-center gap-1.5" data-id="element-185" data-mp="19ha9iacbxx91" data-mpi={i}>
            {i > 0 && <ChevronRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-186" data-mp="19jd99m3ab4qy" />}
            {c.href ? <Link to={c.href} className="hover:text-ink hover:underline" data-id="element-187" data-mp="1eeaeehxg0tyk">
                {c.label}
              </Link> : <span className="font-medium text-ink" aria-current="page" data-id="element-188" data-mp="14hnx234bsl1a">
                {c.label}
              </span>}
          </li>)}
      </ol>
    </nav>;
}